import { Alert } from '@toggle/toggle';

export const MOCK_ALERTS: Alert[] = [
  {
    id: 'alert-001',
    source_id: 'e062e1e3-6038-4004-9bd4-212b8f3e3f91',
    source_type: 'insights',
    title: 'Revenue beat expectations by 12% in Q4',
    created_at: '2026-03-03T09:15:00Z',
    read: false,
    tracking_status: 'active',
    metadata: {
      days_remaining: 14,
    },
  },
  {
    id: 'alert-002',
    source_id: '30c6e77c-59fb-4622-b297-4838a1fc6120',
    source_type: 'insights',
    title: 'Gross margin contracted 200bps sequentially',
    created_at: '2026-03-02T14:30:00Z',
    read: false,
    tracking_status: 'active',
    metadata: {
      days_remaining: 7,
    },
  },
  {
    id: 'alert-003',
    source_id: '126300f6-6a41-40fb-a464-81e6a4289238',
    source_type: 'alfred',
    created_at: '2026-03-01T18:00:00Z',
    read: true,
  },
  {
    id: 'alert-004',
    source_id: '3e388fbf-c6b8-44b4-a800-0ce6448b303d',
    source_type: 'insights',
    title: 'Free cash flow inflected positive after 3 quarters',
    created_at: '2026-02-28T11:45:00Z',
    read: false,
    tracking_status: 'active',
    metadata: {
      days_remaining: 21,
    },
  },
  {
    id: 'alert-005',
    source_id: '126300f6-6a41-40fb-a464-81e6a4289238',
    source_type: 'alfred',
    created_at: '2026-02-27T08:20:00Z',
    read: true,
  },
  {
    id: 'alert-006',
    source_id: '3e388fbf-c6b8-44b4-a800-0ce6448b303d',
    source_type: 'insights',
    title: 'Operating leverage expanding — SG&A declining as % of revenue',
    created_at: '2026-02-26T16:10:00Z',
    read: false,
    tracking_status: 'stopped',
  },
  {
    id: 'alert-007',
    source_id: '3e388fbf-c6b8-44b4-a800-0ce6448b303d',
    source_type: 'insights',
    title: 'Inventory days outstanding rose 15% YoY',
    created_at: '2026-02-25T13:00:00Z',
    read: true,
    tracking_status: 'completed',
    metadata: {
      days_elapsed: 14,
    },
  },
  {
    id: 'alert-008',
    source_id: '126300f6-6a41-40fb-a464-81e6a4289238',
    source_type: 'alfred',
    created_at: '2026-02-24T10:30:00Z',
    read: false,
  },
  {
    id: 'alert-009',
    source_id: '126300f6-6a41-40fb-a464-81e6a4289238',
    source_type: 'alfred',
    created_at: '2026-02-24T10:30:00Z',
    read: false,
  },
  {
    id: 'alert-010',
    source_id: '126300f6-6a41-40fb-a464-81e6a4289238',
    source_type: 'alfred',
    created_at: '2026-02-24T10:30:00Z',
    read: false,
  },
  {
    id: 'alert-011',
    source_id: '126300f6-6a41-40fb-a464-81e6a4289238',
    source_type: 'alfred',
    created_at: '2026-02-24T10:30:00Z',
    read: false,
  },
  {
    id: 'alert-012',
    source_id: '126300f6-6a41-40fb-a464-81e6a4289238',
    source_type: 'alfred',
    created_at: '2026-02-24T10:30:00Z',
    read: false,
  },
  {
    id: 'alert-013',
    source_id: '126300f6-6a41-40fb-a464-81e6a4289238',
    source_type: 'alfred',
    created_at: '2026-02-24T10:30:00Z',
    read: false,
  },
];
